module.exports = __webpack_public_path__ + "static/landing_2-35e023188dc7a81bc6a3dd7ac609a134.png";